import type {
  FeatureToggle,
  FeatureToggleIdentifier,
} from '@schema/featureToggle'

type FeatureToggleLike = Pick<FeatureToggle, 'identifier' | 'enabled'>

/**
 * Returns whether the given identifier is enabled in the toggles list.
 */
export function isFeatureEnabled(
  toggles: FeatureToggleLike[] | undefined,
  identifier: FeatureToggleIdentifier,
): boolean {
  return (
    toggles?.some((ft) => ft.identifier === identifier && ft.enabled) ?? false
  )
}
